module.exports = __webpack_public_path__ + "img/autobuses-loby-3.5eb12033.jpg";